import {
    faBackwardFast,
    faBackwardStep,
    faForwardFast,
    faForwardStep,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { Table } from "@tanstack/react-table";
import { Button } from "frontend-components";
import { useTranslation } from "react-i18next";

export default function Pagination<T>({ table }: { table: Table<T> }) {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center gap-2 mt-4">
            <div className="flex items-center gap-2">
                <Button
                    type="button"
                    variant="outline"
                    size="icon-sm"
                    onClick={() => table.firstPage()}
                    disabled={!table.getCanPreviousPage()}
                    aria-label={t("common.firstPage", "Første side")}
                >
                    <FontAwesomeIcon icon={faBackwardFast} />
                </Button>
                <Button
                    type="button"
                    variant="outline"
                    size="icon-sm"
                    onClick={() => table.previousPage()}
                    disabled={!table.getCanPreviousPage()}
                    aria-label={t("common.previousPage", "Forrige side")}
                >
                    <FontAwesomeIcon icon={faBackwardStep} />
                </Button>
                <span className="px-2 text-sm text-compendia-foreground">
                    {table.getState().pagination.pageIndex + 1} {t("common.of")}{" "}
                    {table.getPageCount()}
                </span>
                <Button
                    type="button"
                    variant="outline"
                    size="icon-sm"
                    onClick={() => table.nextPage()}
                    disabled={!table.getCanNextPage()}
                    aria-label={t("common.nextPage", "Neste side")}
                >
                    <FontAwesomeIcon icon={faForwardStep} />
                </Button>
                <Button
                    type="button"
                    variant="outline"
                    size="icon-sm"
                    onClick={() => table.lastPage()}
                    disabled={!table.getCanNextPage()}
                    aria-label={t("common.lastPage", "Siste side")}
                >
                    <FontAwesomeIcon icon={faForwardFast} />
                </Button>
            </div>
            <div className="text-xs text-compendia-muted">
                {t("common.total")}:{" "}
                <span className="font-semibold text-compendia-foreground">
                    {table.getRowCount()}
                </span>
            </div>
        </div>
    );
}
